import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpTV'

export const streamersList = (params = '') => Http.get(`/streamer-types${serialize(params)}`)
export const streamerByID = (params = '') => Http.get(`/streamer-types/${params}`)
export const streamerCreate = (params = '') => Http.post('/streamer-types', params)
export const streamerUpdate = (params = '') => Http.put(`/streamer-types/${params.id}`, params)
export const streamerDestroy = (params = '') => Http.delete(`/streamer-types/${params.id}`)
